import {
    EDC_LOADING,
    EDC_SET,
    EDC_ERROR,
    EDC_ADD,
    EDC_SHOW,
    EDC_DELETE,
    EDC_RESET,
    EDC_EDIT,
    EDC_CONFIRM,
    EDC_UPDATE
} from './edcActions'

const initialState = {
    loading: false,
    data: [],
    error: null,
    success: null,
    idEdit: null,
    idShow: null,
}

const edcReducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case EDC_LOADING:
            return {
                ...state,
                loading: true,
            }
        case EDC_SET:
            return {
                ...state,
                error: null,
                loading: false,
                data: payload
            }
        case EDC_ADD:
            payload.is_active = payload.is_active === 1
            return {
                ...state,
                loading: false,
                error: null,
                data: [payload, ...state.data],
                success: 'New contact has been added successfully.'
            }
        case EDC_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }
        case EDC_SHOW:
            return {
                ...state,
                idShow: payload
            }
        case EDC_DELETE:
            return {
                ...state,
                success: 'Data has been deleted successfully',
                data: state.data.filter(a => !payload.includes(a.id)),
                loading: false,
            }
        case EDC_EDIT:
            return {
                ...state,
                error: null,
                success: null,
                idEdit: payload
            }
        case EDC_RESET:
            return {
                ...state,
                error: null,
                success: null,
            }
        case EDC_CONFIRM:
            console.log('111111111111', payload, type);

            let newData = state.data.map(d => {
                if (d.id === payload.id) {
                    d.status = payload.type;
                }
                return d
            })

            return {
                ...state,
                data: newData

            }
        case EDC_UPDATE:
            return {
                ...state,
                loading: false,
                data: state.data.map(x => x.id === (state.idEdit || payload.id) ? payload : x),
                success: 'Data has been updated successfully.'
            }
        default:
            return state;
    }
}

export default edcReducer
